/* Date de réception estimée (fiche produit, outil de personnalisation, page panier).
 * Règles atelier (Karim, 15/10) :
 * - standard (Colissimo, point relais) : expédié sous 1 à 3 jours ouvrés, sous réserve de stock ;
 * - express : commande avant 16 h (heure de Paris, jour ouvré) → expédiée le jour même, sinon le jour ouvré suivant.
 * Jours ouvrés = lundi-vendredi hors jours fériés français. Rempli dans chaque [data-pdl] (snippet printtex-date-livraison),
 * y compris ceux ajoutés plus tard (panier rechargé). Test : ?pdl_maintenant=2026-10-16T15:00 (heure de Paris). */
(() => {
  if (window.printtexDateLivraison) return;
  // Textes traduits (dictionnaire printtex-site-traductions, vide en français) ; {x} = valeur insérée.
  const ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s);
  const ptxF = window.ptxF || (window.ptxF = (s, v) => ptxT(s).replace(/\{(\w+)\}/g, (m, k) => (v && k in v ? v[k] : m)));
  const LANGUE = document.documentElement.lang || 'fr';

  const REGLES = {
    expedition: [1, 3],   // standard : expédié sous 1 à 3 jours ouvrés après la commande
    transport: [1, 4],    // Colissimo et point relais : jours ouvrés entre l'expédition et la réception
    heureExpress: 16,     // express : avant cette heure (Paris), expédié le jour même
    transportExpress: 1,  // express : reçu le jour ouvré suivant l'expédition
    delaiLong: [3, 4]     // jours ouvrés en plus pour les produits tagués « delai-long » (vêtement commandé au fournisseur)
  };

  // Dates manipulées en UTC midi : pas de décalage d'heure d'été ni de fuseau du visiteur.
  const jour = (a, m, j) => new Date(Date.UTC(a, m, j, 12));
  const cle = (d) => d.toISOString().slice(0, 10);
  const plus = (d, n) => jour(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + n);

  const cacheFeries = {};
  function feries(an) {
    if (cacheFeries[an]) return cacheFeries[an];
    // Pâques (algorithme de Meeus) : lundi de Pâques, Ascension, lundi de Pentecôte.
    const a = an % 19, b = Math.floor(an / 100), c = an % 100;
    const d = (19 * a + b - Math.floor(b / 4) - Math.floor((b - Math.floor((b + 8) / 25) + 1) / 3) + 15) % 30;
    const e = (32 + 2 * (b % 4) + 2 * Math.floor(c / 4) - d - (c % 4)) % 7;
    const m = Math.floor((a + 11 * d + 22 * e) / 451);
    const paques = jour(an, Math.floor((d + e - 7 * m + 114) / 31) - 1, ((d + e - 7 * m + 114) % 31) + 1);
    return (cacheFeries[an] = new Set([
      jour(an, 0, 1), plus(paques, 1), jour(an, 4, 1), jour(an, 4, 8), plus(paques, 39), plus(paques, 50),
      jour(an, 6, 14), jour(an, 7, 15), jour(an, 10, 1), jour(an, 10, 11), jour(an, 11, 25)
    ].map(cle)));
  }
  const ouvre = (d) => d.getUTCDay() % 6 !== 0 && !feries(d.getUTCFullYear()).has(cle(d));
  function ouvresApres(d, n) {
    while (n > 0) { d = plus(d, 1); if (ouvre(d)) n--; }
    return d;
  }

  // Date et heure actuelles à Paris, quel que soit le fuseau de l'appareil.
  function maintenantParis() {
    const test = new URLSearchParams(location.search).get('pdl_maintenant');
    const m = test && test.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (m) return { date: jour(+m[1], +m[2] - 1, +m[3]), heure: +m[4] + m[5] / 60 };
    const p = Object.fromEntries(new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).map((x) => [x.type, x.value]));
    return { date: jour(+p.year, +p.month - 1, +p.day), heure: +p.hour + p.minute / 60 };
  }

  function calcul(delaiLong) {
    const { date, heure } = maintenantParis();
    const long = delaiLong ? REGLES.delaiLong : [0, 0];
    const avantExpress = ouvre(date) && heure < REGLES.heureExpress && !delaiLong;
    // Délai long : express expédié dès réception du vêtement (au plus tard).
    const expressExpedie = delaiLong ? ouvresApres(date, long[1]) : avantExpress ? date : ouvresApres(date, 1);
    return {
      aujourdhui: date,
      avantExpress,
      long,
      recuMin: ouvresApres(date, REGLES.expedition[0] + long[0] + REGLES.transport[0]),
      recuMax: ouvresApres(date, REGLES.expedition[1] + long[1] + REGLES.transport[1]),
      expressExpedie,
      express: ouvresApres(expressExpedie, REGLES.transportExpress)
    };
  }

  const fmt = (d, opts) => d.toLocaleDateString(LANGUE, { timeZone: 'UTC', ...opts });
  const court = (d) => fmt(d, { weekday: 'short', day: 'numeric' });            // « ven. 16 »
  const complet = (d) => fmt(d, { weekday: 'short', day: 'numeric', month: 'short' }); // « ven. 16 oct. »
  function quand(d, auj, sansLe) {
    if (cle(d) === cle(auj)) return ptxT('aujourd’hui');
    if (cle(d) === cle(plus(auj, 1))) return ptxT('demain');
    return sansLe ? complet(d) : ptxF('le {date}', { date: complet(d) });
  }
  const debutPlage = (a, b) => (a.getUTCMonth() === b.getUTCMonth() ? court(a) : complet(a));

  function remplir(el) {
    const r = calcul(el.dataset.pdlDelaiLong === 'true');
    const mode = el.dataset.pdlMode;
    const reserve = `<span class="pdl__reserve">${ptxT('(sous réserve de stock)')}</span>`;
    const recu = ptxF('reçu <strong>entre le {debut} et le {fin}</strong>', { debut: debutPlage(r.recuMin, r.recuMax), fin: complet(r.recuMax) });
    const exp = REGLES.expedition.map((n, i) => n + r.long[i]);
    const express = r.avantExpress
      ? ptxF('Express : commandez avant {heure} h, expédié aujourd’hui, reçu {recu}', { heure: REGLES.heureExpress, recu: quand(r.express, r.aujourdhui) })
      : ptxF('Express : expédié {expedie}, reçu {recu}', { expedie: quand(r.expressExpedie, r.aujourdhui), recu: quand(r.express, r.aujourdhui) });
    if (mode === 'mini') {
      // Barre du bas de l'outil (place comptée sur mobile).
      el.innerHTML = `<span class="pdl__ligne">${ptxF('Reçu <strong>{debut} – {fin}</strong> · express : reçu <strong>{express}</strong>', { debut: debutPlage(r.recuMin, r.recuMax), fin: complet(r.recuMax), express: quand(r.express, r.aujourdhui, true) })}</span>`;
    } else if (mode === 'court') {
      el.innerHTML = `<span class="pdl__ligne">${ptxF('Expédié sous {min} à {max} jours ouvrés', { min: exp[0], max: exp[1] })} · ${recu} ${reserve}</span>`;
    } else {
      el.innerHTML = `<span class="pdl__ligne">${ptxF('Expédié sous {min} à {max} jours ouvrés', { min: exp[0], max: exp[1] })} · ${recu}</span>` +
        `<span class="pdl__options">${express} · ${ptxT('retrait gratuit à l’atelier')} ${reserve}</span>`;
    }
    el.hidden = false;
  }

  const tout = (racine) => (racine.querySelectorAll ? racine.querySelectorAll('[data-pdl]') : []).forEach(remplir);

  window.printtexDateLivraison = { calcul, remplir, REGLES };
  const demarrer = () => {
    tout(document);
    // Tiroir panier et outil rechargés : remplir les nouveaux encarts.
    new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach((n) => {
      if (n.nodeType !== 1) return;
      if (n.matches('[data-pdl]')) remplir(n); else tout(n);
    }))).observe(document.body, { childList: true, subtree: true });
    // Page restée ouverte : passer midi ou minuit met le texte à jour.
    setInterval(() => tout(document), 60000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer); else demarrer();
})();
